<template>
    <div class="searchbox-container">
        <div class="searchbox-box">
            <h1 class="logo">
                <el-link href="#/home" :underline="false"><img src="../../../assets/images/logo.png" /></el-link>
            </h1>
            <div class="flex1 flex_column">
                <div class="flex_center" style="justify-content: space-between;">
                    <div class="search-container">
                        <el-autocomplete v-if="search_type_index == 0" v-model="search_value" :placeholder="search_tab_list[search_type_index].placeholder
                            " :fetch-suggestions="querySearch" @focus="handleFocus($event.target.value)" @input="handleInput"
                            @select="handleSelect" class="search-ipt my-autocomplate">
                            <template slot-scope="{ item }">
                                <div class="item">{{ item }}</div>
                            </template>
                        </el-autocomplete>
                        <input type="text" v-else v-model="search_value" :placeholder="search_tab_list[search_type_index].placeholder
                            " class="search-ipt" />
                        <div class="search-btn" @click="handleSearch()">
                            <span v-if="search_plan == '0'">搜索</span>
                            <span v-else>自营搜索</span>
                        </div>
                        <div class="search-type" v-if="showType == 0">
                            <div :class="search_type_index == index
                                ? 'search-type-item select-type'
                                : 'search-type-item'
                                " v-for="(item, index) in search_tab_list" :key="index" @click="chooseType(index)">
                                {{ item.name }}
                            </div>
                        </div>

                        <!-- <div class="hot-search">
                            <div class="hot-item" v-if="hot_search.length">热门搜索：</div>
                            <div class="hot-item" v-for="(item, index) in hot_search" :key="index"
                                @click="handleSearch(item.name)">
                                {{ item.name }}
                            </div>
                        </div> -->
                    </div>
                    <div class="order-btn-container" :style="crePlanList.totalRows == 0
                        ? 'margin-left:110px;'
                        : 'margin-left:10px;'
                        ">
                        <div class="caigou-btn" @click="jumpUrl('procurementCenter')">
                            <div class="ico"></div>
                            采购中心
                        </div>
                        <div class="order-btn" @click="jumpUrl('purchaseList')">
                            <div class="ico"></div>
                            我的购物车
                            <div class="order-sum" v-if="$store.state.purchase_list.goodsNum">
                                {{ $store.state.purchase_list.goodsNum }}
                            </div>
                            <div class="order-sum" v-else>0</div>

                            <div class="order-detail" @click.stop v-if="$store.state.purchase_list.list">
                                <div>
                                    <div class="order-detail-item" v-for="(item, index) in $store.state
                                        .purchase_list.list" :key="index">
                                        <img class="order-icon" :src="$imgpath + item.goodsImages"
                                            :onerror="errorGoodsImg" />
                                        <div class="order-goodsname">
                                            {{ item.goodsName }}
                                        </div>
                                        <div class="order-goodsprice">
                                            <p>
                                                ￥{{ item.goodsPrice }}×{{
                                                    item.goodsNum
                                                }}
                                            </p>
                                            <p @click="handleDel(item)">删除</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="total-sum">
                                    共
                                    <span class="total-num">{{
                                        $store.state.purchase_list.goodsNum
                                    }}</span>
                                    件商品 共计
                                    <span class="total-num">{{
                                        $store.state.purchase_list.goodsTotalPrice
                                        | numFilter
                                    }}</span>
                                    元

                                    <span class="total-btn" @click="jumpUrl('purchaseList')">去结算</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="crePlanList.totalRows > 0" class="caigou-btn plan-btn" @click="jumpUrl('buyList')">
                            <div class="icoo"></div>
                            采购计划
                        </div>
                    </div>
                </div>
                <div class="hot-search textone">
                    <div class="hot-item" v-if="hot_search.length">热门搜索：</div>
                    <div class="hot-item" v-for="(item, index) in hot_search" :key="index" @click="handleSearch(item.name)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { deleteGoods, cart, findCrePlan, getRecommendedWords, getHotSearch } from "@/api/searchbox";
import jsCookie from 'js-cookie'
import qs from "qs";

import { Message, MessageBox } from "element-ui";

export default {
    inject: ["reload"],
    name: "searchBox",
    data() {
        return {
            search_value: null,
            search_tab_list: [
                {
                    name: "商品",
                    type: "goods",
                    placeholder: "请输入商品名称",
                },
                {
                    name: "商品货号",
                    type: "goods_num",
                    placeholder: "请输入商品货号",
                },
                {
                    name: "69码",
                    type: "upc69",
                    placeholder: "请输入69码",
                },
                {
                    name: "店铺",
                    type: "store_name",
                    placeholder: "请输入店铺名称",
                },
            ],
            errorGoodsImg:
                "this.src='" + require("@/assets/images/goods_error.png") + "'",
            hot_search: [
                // {
                //     name: "口罩",
                // },
                // {
                //     name: "安全鞋",
                // },
                // {
                //     name: "安全帽",
                // },
                // {
                //     name: "手套",
                // },
                // {
                //     name: "劳保鞋",
                // },
                // {
                //     name: "内六角扳手",
                // },
                // {
                //     name: "轴承",
                // },
                // {
                //     name: "A4纸",
                // },
            ],
            search_type_index: 0,
            order_sum: 0,
            purchase_list: {},
            search_plan: "0",
            crePlanList: [],
            suggestions: [], // 用于存储获取到的数据
            isDropdownOpen: false // 添加一个标志位用于控制下拉菜单的显示
        };
    },
    props: ["showType"],
    components: {},
    filters: {
        numFilter(value) {
            // 截取当前数据到小数点后两位
            let realVal = parseFloat(value).toFixed(2);
            return realVal;
        },
    },
    created() {
        this.search_type_index = this.$store.state.search_type;
        if (this.$route.name == "buyList") {
            if (this.$route.query && this.$route.query.buyListSearchType) {
                this.search_type_index = this.$route.query.buyListSearchType
            }
        }
        if (
            this.$route.name == "smartwin" ||
            this.$route.name == "proprietaryGoods"
        ) {
            this.search_plan = "1";
            this.search_tab_list = [
                {
                    name: "商品",
                    type: "goods",
                    placeholder: "请输入商品名称",
                },
                {
                    name: "商品货号",
                    type: "goods_num",
                    placeholder: "请输入商品货号",
                },
                {
                    name: "69码",
                    type: "upc69",
                    placeholder: "请输入69码",
                }
            ];
        } else {
            this.search_plan = "0";
            this.search_tab_list = [
                {
                    name: "商品",
                    type: "goods",
                    placeholder: "请输入商品名称",
                },
                {
                    name: "商品货号",
                    type: "goods_num",
                    placeholder: "请输入商品货号",
                },
                {
                    name: "69码",
                    type: "upc69",
                    placeholder: "请输入69码",
                },
                {
                    name: "店铺",
                    type: "store_name",
                    placeholder: "请输入店铺名称",
                }
            ];
        }
        this.getCrePlan();
        this.getHotSearchData();
    },
    computed: {
        isLogin() {
            return this.$store.state.login_status;
        },
    },
    methods: {
        //获取热门搜索
        getHotSearchData() {
            getHotSearch({}).then(res => {
                console.log(res)
                let hot_search = []
                if (res.ok) {
                    let keywords = res.keywords;
                    if (keywords.length) {
                        keywords.map(item => {
                            hot_search.push({
                                name: item
                            })
                        })
                    }
                }
                this.hot_search = hot_search
            })
        },
        handleFocus(val) {
            if (val == null) val = ''
            console.log('聚焦是否进入此处');
            if(!val) {
                this.suggestions=[];
                return;
            }
            this.fetchData(val);
        },
        handleInput(val) {
            this.fetchData(val)
            this.isDropdownOpen = true; // 手动打开下拉菜单
        },
        handleSelect(item) {
            this.search_value = item;
            this.fetchData(item)
            setTimeout(() => {
                this.handleSearch();
            }, 1000)
        },
        //获取建议数据
        fetchData(val) {
            if(val.indexOf(' ')>-1){
                val=val.replace(/\s/g, '')
            }
            getRecommendedWords({
                query: val
            }).then(res => {
                console.log(res);
                if (res.ok) {
                    console.log(res.keywords);
                    if (res.keywords.length > 0) {
                        // res.keywords.map(item=>{
                        //     this.suggestions.push({
                        //         name:item
                        //     })
                        // })
                        this.suggestions = res.keywords
                        console.log(this.suggestions)
                    }
                }
            })
        },
        querySearch(queryString, cb) {
            // 在这里编写搜索逻辑
            // 可以使用异步请求或者从本地数据搜索
            // 将搜索结果通过回调函数传递给el-autocomplete组件
            const results = queryString ? this.suggestions.filter(item => item.includes(queryString)) : this.suggestions;
            cb(results);
        },
        chooseType(select_index) {
            // 0 => 商品 1 => 商品货号 2 => 店铺
            this.search_type_index = select_index;
        },
        handleSearch(searchValue) {
            console.log('当前值'+searchValue)
            let that = this;
            // 采购计划
            if (this.$route.path == "/buyList") {
                console.log('从采购计划进入');
                console.log(searchValue);
                // if (searchValue) {
                //     console.log('热门')
                // } else {
                //     that.$router.push({
                //         name: "buyList",
                //         query: {
                //             keyword: that.search_value,
                //         },
                //     });
                // }
                if (that.search_type_index == 0) {
                    if (searchValue) {
                        that.search_value = searchValue;

                        that.$router.push({
                            name: "goodsList",
                            query: {
                                searchType: that.search_type_index,
                                keyword: that.search_value,
                            },
                        });
                    } else {
                        that.$router.push({
                            name: "buyList",
                            query: {
                                keyword: that.search_value,
                                buyListSearchType: that.search_type_index,
                                time: new Date().getTime()
                            },
                        });
                    }
                } else if (that.search_type_index == 1||that.search_type_index == 2) {
                    console.log('当前索引'+that.search_type_index)
                    if (searchValue) {
                        console.log('当前索引'+that.search_type_index)
                        that.search_value = searchValue;

                        this.$router.push({
                            name: "goodsList",
                            query: {
                                searchType: that.search_type_index,
                                goodsNum: that.search_value,
                            },
                        });
                    } else {
                        console.log('当前索引buyList'+that.search_type_index)
                        that.$router.push({
                            name: "buyList",
                            query: {
                                keyword: that.search_value,
                                buyListSearchType: that.search_type_index,
                                time: new Date().getTime()
                            },
                        });
                    }
                } else {
                    if (searchValue) {
                        that.search_value = searchValue;

                        this.$router.push({
                            name: "shoplist",
                            query: {
                                word: that.search_value,
                            },
                        });
                    } else {
                        that.$router.push({
                            name: "buyList",
                            query: {
                                keyword: that.search_value,
                                buyListSearchType: that.search_type_index,
                                time: new Date().getTime()
                            },
                        });
                    }
                }
            } else {
                // 正常搜索
                this.$store.commit("addSearchstatus");

                if (that.search_type_index == 0) {
                    if (searchValue) {
                        that.search_value = searchValue;
                    }

                    if (that.$route.name == "smartwin") {
                        that.$router.push({
                            name: "proprietaryGoods",
                            query: {
                                searchType: that.search_type_index,
                                keyword: that.search_value,
                            },
                        });
                    } else {
                        console.log('@@@@','是否进入此处');
                        that.$router.push({
                            name: "goodsList",
                            query: {
                                searchType: that.search_type_index,
                                keyword: that.search_value,
                                search_plan:that.search_plan
                            },
                        });
                    }
                } else if (that.search_type_index == 1||that.search_type_index == 2) {
                    if (searchValue) {
                        that.search_value = searchValue;
                    }

                    if (that.$route.name == "smartwin") {
                        this.$router.push({
                            name: "proprietaryGoods",
                            query: {
                                searchType: that.search_type_index,
                                goodsNum: that.search_value,
                            },
                        });
                    } else {
                        this.$router.push({
                            name: "goodsList",
                            query: {
                                searchType: that.search_type_index,
                                goodsNum: that.search_value,
                            },
                        });
                    }
                } else {
                    if (searchValue) {
                        that.search_value = searchValue;
                    }
                    this.$router.push({
                        name: "shoplist",
                        query: {
                            word: that.search_value,
                        },
                    });
                }
            }
        },
        jumpUrl(url) {
            console.log(url);
            if (url == "procurementCenter") {
                if (jsCookie.get("Authorization")) {//当前处于登录状态
                    this.$router.push({
                        name: url,
                        query: {
                            type: 1,
                        },
                    });
                } else {
                    this.$router.push({
                        path: '/login'
                    });
                }
            } else {
                this.$router.push({
                    name: url,
                });
            }
        },
        getCrePlan() {
            findCrePlan().then((res) => {

                this.crePlanList = res;
            });
        },
        reloadCart() {
            cart().then((res) => {
                if (res.success) {
                    this.$store.commit("changeLogin", 1);
                    this.$store.commit("setPurchaselist", res.result);
                } else {
                    this.$store.commit("changeLogin", 0);
                    this.$store.commit("setPurchaselist", {});
                }
            });
        },
        handleDel(row) {
            let that = this;
            MessageBox.confirm("确认删除商品？", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteGoods(
                        qs.stringify({
                            cartId: row.cartId,
                        })
                    ).then((res) => {
                        console.log(res);
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.reloadCart();
                            this.reload();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.message,
                            });
                        }
                    });
                })
                .catch(() => {
                    console.log("取消删除");
                });
        },
    },
    watch: {
        $route: {
            handler(nv, ov) {
                if (
                    this.$route.name == "smartwin" ||
                    this.$route.name == "proprietaryGoods"
                ) {
                    this.search_plan = "1";
                    this.search_tab_list = [
                        {
                            name: "商品",
                            type: "goods",
                            placeholder: "请输入商品名称",
                        },
                        {
                            name: "商品货号",
                            type: "goods_num",
                            placeholder: "请输入商品货号",
                        },
                        {
                            name: "69码",
                            type: "upc69",
                            placeholder: "请输入69码",
                        },
                    ];
                } else {
                    this.search_plan = "0";
                    this.search_tab_list = [
                        {
                            name: "商品",
                            type: "goods",
                            placeholder: "请输入商品名称",
                        },
                        {
                            name: "商品货号",
                            type: "goods_num",
                            placeholder: "请输入商品货号",
                        },
                        {
                            name: "69码",
                            type: "upc69",
                            placeholder: "请输入69码",
                        },
                        {
                            name: "店铺",
                            type: "store_name",
                            placeholder: "请输入店铺名称",
                        }
                    ];
                    if (nv.query.keyword && nv.name == 'buyList' && ov.name == 'buyList') {
                        this.search_value = nv.query.keyword;
                        this.search_type_index = nv.query.buyListSearchType;
                    }
                    if (nv.name != ov.name && ov.name == "buyList") {
                        this.search_value = '';
                    }
                    if (nv.name != ov.name && nv.name == "shoplist") {
                        this.search_value = nv.query.word;
                    }
                }
            },
        },
        isLogin(newVal, oldVal) { },
        deep: true,
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/deep/ .my-autocomplate {
    padding: 0 !important;

    .el-input__inner {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        border: 0;
        background: transparent;

        &::placeholder {
            color: #666;
            font-size: 14px;
        }
    }
}

/deep/ .el-autocomplete-suggestion {
    width: 444px;
    left: 279px;
}

.searchbox-container {
    width: 100%;
    height: 120px;
    background: #ffffff;

    .searchbox-box {
        width: 1200px;
        height: 120px;
        margin: 0 auto;
        background: #fff url(../../../assets/images/header_background.png) 0 0 no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;
        overflow: hidden;

        .logo {
            margin-right: 20px;

            img {
                width: 260px;
                height: 58px;
            }
        }

        .search-container {
            //height: 98px;
            height: 70px;
            display: flex;
            flex-direction: row;
            align-items: center;
            //align-items: end;
            position: relative;
            margin-top: 16px;
            .search-ipt {
                border: 2px solid #e63535;
                color: #333;
                padding: 0 20px;
                width: 400px;
                height: 16px;
                height: 40px;
                border-radius: 3px 0px 0px 3px;
                box-sizing: initial;

                &:focus {
                    outline: none;
                }
            }

            .search-btn {
                width: 88px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                background-color: #e63535;
                color: #fff;
                font-size: 14px;
                cursor: pointer;
            }

            .search-type {
                // width: 200px;
                width: 240px;
                height: 24px;
                position: absolute;
                left: 0;
                // top: 3px;
                top: -11px;
                font-size: 12px;
                display: flex;
                flex-direction: row;
                box-sizing: border-box;

                .search-type-item {
                    width: 66px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    cursor: pointer;
                }

                .select-type {
                    background: #e63535;
                    color: #ffffff;
                }
            }

            .hot-search {
                width: 444px;
                height: 30px;
                line-height: 30px;
                position: absolute;
                left: 0;
                bottom: -5px;
                display: flex;
                flex-direction: row;
                font-size: 12px;
                color: #999999;

                .hot-item {
                    margin-right: 6px;
                    cursor: pointer;

                    &:nth-child(1) {
                        cursor: default;
                    }
                }
            }
        }

        .hot-search {
            height: 30px;
            line-height: 30px;
            // position: absolute;
            // left: 0;
            // bottom: -5px;
            display: flex;
            flex-direction: row;
            white-space: nowrap;
            font-size: 12px;
            color: #999999;
            margin-top: -11px;
            .hot-item {
                margin-right: 6px;
                cursor: pointer;

                &:nth-child(1) {
                    cursor: default;
                }
            }
        }

        .order-btn-container {
            //height: 98px;
            height: 66px;
            display: flex;
            flex-direction: row;
            align-items: center;
            //align-items: end;
            margin-left: auto;
            margin-left: 10px;
            margin-top: 16px;
            .caigou-btn {
                width: 100px;
                height: 40px;
                line-height: 40px;
                text-indent: 30px;
                background: #ffffff;
                border: 1px solid #e4e4eb;
                border-radius: 3px;
                font-size: 16px;
                color: #333333;
                cursor: pointer;
                position: relative;
                margin-right: 10px;

                &:hover {
                    background: #e63535;
                    border: 1px solid #e63535;
                    color: #ffffff;

                    .ico {
                        background-position: 0 -71px;
                    }
                }

                .ico {
                    position: absolute;
                    top: 8px;
                    left: 5px;
                    width: 22px;
                    height: 22px;
                    background: url(../../../assets/images/page_ico.png) no-repeat 0 0;
                }
            }

            .order-btn {
                width: 149px;
                height: 40px;
                line-height: 40px;
                text-indent: 30px;
                background: #ffffff;
                border: 1px solid #e4e4eb;
                border-radius: 3px;
                font-size: 16px;
                color: #333333;
                cursor: pointer;
                position: relative;
                margin-right: 10px;

                .ico {
                    position: absolute;
                    top: 7px;
                    left: 5px;
                    width: 23px;
                    height: 23px;
                    background: url(../../../assets/images/page_ico.png) 0 -34px no-repeat;
                }

                .order-sum {
                    width: 30px;
                    height: 16px;
                    display: inline-block;
                    line-height: 16px;
                    text-align: center;
                    background: #ff0000;
                    font-size: 12px;
                    border-radius: 50px;
                    text-indent: 0 !important;
                    color: #ffffff;
                    position: relative;
                }

                .order-detail {
                    width: 406px;
                    padding: 10px;
                    position: absolute;
                    top: 41px;
                    right: -2px;
                    z-index: 9999;
                    border: 1px solid #ddd;
                    background: #ffffff;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
                    display: none;
                    border-radius: 3px 0 3px 3px;

                    .order-detail-item {
                        padding: 10px 5px;
                        width: calc(100% - 20px);
                        height: 40px;
                        border-bottom: 1px solid #dfdfdf;
                        box-sizing: initial;
                        margin: 0 auto;
                        color: #000000;
                        overflow: hidden;

                        &:last-child {
                            border: none;
                            margin-bottom: 20px;
                        }

                        .order-icon {
                            width: 40px;
                            height: 40px;
                            margin-right: 10px;
                            float: left;
                        }

                        .order-goodsname {
                            font-size: 12px;
                            color: #333333;
                            text-indent: 0;
                            width: 200px;
                            line-height: 20px;
                            text-align: left;
                            float: left;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;

                            &:hover {
                                color: #b10b15;
                            }
                        }

                        .order-goodsprice {
                            float: right;
                            text-indent: 0;

                            p {
                                &:nth-child(1) {
                                    width: 120px;
                                    height: 20px;
                                    line-height: 20px;
                                    text-align: right;
                                    font-size: 14px;
                                    font-weight: bold;
                                    color: #f40;
                                }

                                &:nth-child(2) {
                                    width: 120px;
                                    height: 20px;
                                    line-height: 20px;
                                    text-align: right;
                                    font-size: 12px;
                                    color: #666666;
                                }
                            }
                        }
                    }

                    .total-sum {
                        padding: 10px;
                        height: 30px;
                        line-height: 30px;
                        text-indent: 0;
                        font-size: 12px;
                        color: #666666;
                        vertical-align: middle;
                        text-align: left;
                        color: #666;
                        background-color: #f5f5f5;
                        display: flex;

                        .total-num {
                            font-weight: bold;
                            color: #b10b15;
                            margin: 0 8px;
                        }

                        .total-btn {
                            margin-left: auto;
                            padding: 0 15px;
                            height: 30px;
                            line-height: 30px;
                            font-size: 14px;
                            background-color: #d21d27;
                            border-radius: 3px;
                            color: #fff;
                        }
                    }
                }

                &:hover {
                    background: #e63535;
                    border: 1px solid #e63535;
                    color: #ffffff;

                    .order-detail {
                        display: block;
                    }

                    .order-detail-item {
                        color: #b10b15;
                    }

                    .ico {
                        background-position: 0 -106px;
                    }

                    .order-sum {
                        color: #d21d27;
                        background: #ffffff;
                    }
                }
            }

            .plan-btn {
                &:hover {
                    .icoo {
                        position: absolute;
                        top: 9px;
                        left: 5px;
                        width: 20px;
                        height: 20px;
                        background: url(../../../assets/images/plan_act.png);
                        background-size: 100%;
                    }
                }

                .icoo {
                    position: absolute;
                    top: 9px;
                    left: 5px;
                    width: 20px;
                    height: 20px;
                    background: url(../../../assets/images/plan.png);
                    background-size: 100%;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/searchBox.vue